import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { ErrorMessages } from '../types'

const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE
// NOTE: The US values are NOT converted from the mm values. The US shop works in inches and has its
// own min / max limits, so they intentionally do not match a mm -> inch conversion
// (e.g. 585 mm ≈ 23.03 in, but the US max width is 24 in).
// Do not replace them with mmToInches() - update each value separately if a limit changes.
export const minValue = defaultLocale === 'us' ? 0.75 : 20
export const maxWidth = defaultLocale === 'us' ? 24 : 585
export const maxHeight = defaultLocale === 'us' ? 11.5 : 308

const isInRange = (value: string, max: number) =>
  value !== '' && !isNaN(Number(value)) && Number(value) >= minValue && Number(value) <= max

export const schema = (texts: ErrorMessages) => {
  const formSchema = z
    .object({
      shape: z.string().min(1, texts.required),
      diameter: z.string(),
      height: z.string(),
      width: z.string(),
      foil: z.string(),
      opaque: z.string()
    })

    .superRefine((data, ctx) => {
      const { shape, diameter, height, width } = data
      if (shape === '2') {
        if (!isInRange(diameter, maxHeight)) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['diameter'], message: texts.width_error })
        }
        return
      }

      if (shape === '1' || shape === '3') {
        if (!isInRange(width, maxWidth)) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['width'], message: texts.width_error })
        }
        if (!isInRange(height, maxHeight)) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['height'], message: texts.height_error })
        }
      }
    })
  return formSchema
}

export const schemaResolver = (texts: ErrorMessages) => zodResolver(schema(texts))
